require('@/play/game/safari.js');
import { clone } from 'lodash';
const loaderPool = [];
let queued = [];
let loaderPoolSize = 1;
let loader, resources, busy, started, errors;
const ErrorImage = 'data:image/png;base64,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'


function addToLoader(lst, loader) {
  lst.forEach( ({url,loaderOpts,callback}) => {
    //console.log('[LOADER]', loader.__num, 'request', url, 'for loading');
    //TODO: revert
    if (resources[url]) {
      //console.log('[LOADER]', loader.__num, url, 'already loaded');
      try {
        return callback();
      } catch (e) {
        //console.error('[LOADER]', loader.__num, 'error', url);
      }
    }

    const alreadyLoading = loader.__queued.filter( (o) => {
      return o.url === url;
    })
    if (!alreadyLoading.length) {
      //console.log('[LOADER]', loader.__num, 'add', url, 'for loading', loaderOpts);
      loader.add(url,loaderOpts);
      loader.__queued.push({url,loaderOpts,cbs:[callback]});
    } else {
      //console.log('[LOADER]', loader.__num, url, 'already loading...');
      alreadyLoading[0].cbs.push(callback);
    }
  });
  loader.load();
}
if (process.browser) {
  //require('pixi-spine')

  for (let i = 0; i < loaderPoolSize; i++) {
    window.PIXI = PIXI;
    loader = new PIXI.Loader()
    loader.__errors = {};
    loader.__num = i;
    loader.__queued = [];

    function onComplete() {
      //console.log('[LOADER]', loader.__num, 'onComplete');
      loader.__queued.forEach( ({url,loaderOpts,cbs}) => {
        //console.log('[LOADER]', loader.__num, 'onComplete', url);
        if (errors[url]) {
          cbs.forEach( (callback) => {
            callback(errors[url]);
          });
        } else {
          if (!resources[url]) {
            //console.log('[LOADER]', loader.__num, 'onComplete', 'set', url, 'to', loader.resources[url]);
            resources[url] = loader.resources[url];
          }
          cbs.forEach( (callback) => {
            try {
              callback();
            } catch (e) {
              //console.error('[LOADER]', loader.__num, 'error', url);
            }
          });

        }
      });
      loader.__queued = [];

      //console.log('[LOADER]', loader.__num, 'still in queue', queued.length);
      if (queued.length) {
        //console.log('[LOADER]', loader.__num, 'still stuff to load?');
        loader.reset();
        const lol = clone(queued);
        queued = [];
        addToLoader(lol, loader);
      } else {
        //console.log('[LOADER]', loader.__num, 'put loader back in pool');
        loaderPool.push(loader);
      }
    }

    loader.onError.add( (err, loader, resource) => {
      let {url} = resource;
      console.log('error on url',url,err);
      loader.__queued.forEach( ({url,cbs}) => {
        if (url === resource.url) {
          errors[url] = err;
          //cbs.forEach( (cb) => {
            //cb(err + ': ' + url);
          //});
        }
      });
      onComplete();
    })
    loader.onComplete.add(onComplete);

    loaderPool.push(loader)
  }

  resources = loader.resources;
  resources.__error = PIXI.Texture.from(ErrorImage);
  errors = {};
  busy = [];
  started = false;
} else {
  busy = [];
  queued = []
  resources = {};
  errors = {};
  started = false;
}

function load(url, callback) {
  if (!process.browser) {
    return;
  }

  // TODO: put back
  if (resources[url]) {
    //console.log('[LOADER]', url, 'already loaded');
    return callback();
  }
  
  if (!loaderPool.length) {
    queued.push({url,callback});
    //console.log('[LOADER]', url, 'no available loaders', 'queue length', queued.length);
    return;
  }

  const loader = loaderPool.pop();
  console.log('[LOADER]', url, 'got loader', loader.__num);
  let loaderOpts = undefined;
  if (url.indexOf('.json') === -1) {
      if (url.toLowerCase().indexOf('.jpg') || url.toLowerCase().indexOf('.jpeg') || url.toLowerCase().indexOf('png') || url.toLowerCase().indexOf('webp') || url.toLowerCase().indexOf('gif')) {
        loaderOpts = {
          // nothing in here on purpose
        }
    } else {
      // WTF: this is because Pixi is retarded and this magic
      // needs to be set to load images with no extension
      // but not for the atlases, otherwise they break
      // lol.
      loaderOpts = {
        loadType: 'image',
        xhrType: 'blob'
      };
    }
  }
  /*
  if (opts.image) {
    loaderOpts.loadType = PIXI.Resource.LOAD_TYPE.IMAGE
  }
    loaderOpts.loadType = PIXI.Resource.LOAD_TYPE.IMAGE
    */

  loader.add(url, loaderOpts)
  loader.__queued.push({url,loaderOpts,cbs:[callback]});
  loader.load();

}

export default {
  load,
  resources
}



